import React from 'react'
import { Search } from 'lucide-react'
import styles from 'components/quests/quest-not-found.module.scss'

interface QuestNotFoundProps {
    error?: Error | { status?: number; message?: string }
}

export default function QuestNotFound({ error }: QuestNotFoundProps) {
    const is404 = error && 'status' in error && error.status === 404
    const is422 = error && 'status' in error && error.status === 422
    const message = is404
        ? 'Thread not found.'
        : is422
        ? 'Thread could not be posted.'
        : 'Thread error.'

    return (
        <div className={styles.questNotFoundComp}>
            <div className={styles.iconContainer}>
                <Search size={60} />
            </div>

            <div className={styles.messageContainer}>{message}</div>
        </div>
    )
}
